module.exports = __webpack_public_path__ + "static/assets/e2289bc94a17792e3abea55cd339bbcd.jpg";